import { render, staticRenderFns } from "./ItemDetails_Details.vue?vue&type=template&id=7f9aa1d0&"
import script from "./ItemDetails_Details.vue?vue&type=script&lang=js&"
export * from "./ItemDetails_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports